module.exports = __webpack_public_path__ + "img/w3_circle_down_black.122986fb.122986fb.png";